export default __webpack_public_path__ + "static/media/image10tum.8de1123e.jpg";